//-------------MONITORING_COPY--------------
import React from 'react';
import SearchInputByName from 'Shared/SearchInputByName';
import {StationSearchByNameProps} from "../../../Filters/Stations/StationSearchByName";


/** Строка ввода поискового текста для станций, где при updateValue происходит задержка (debounce) */
export function StationSearchByNameMonitoring({ text, updateText, debounceDelay }: StationSearchByNameProps) {
    return (
        <SearchInputByName
            placeholder="Название станции..."
            value={text}
            updateValue={updateText}
            debounceDelay={debounceDelay}
        />
    );
}
export const MemoStationSearchByNameMonitoring = React.memo(StationSearchByNameMonitoring);
MemoStationSearchByNameMonitoring.displayName = 'MemoStationSearchByNameMonitoring';
export default StationSearchByNameMonitoring;